import React from 'react';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';

export default function DisabledSourceChip() {
    const intl = useIntl();
    return (
        <Chip
            size="small"
            variant="outlined"
            label={intl.formatMessage({ id: 'monitoring.status.disabled' })}
            sx={{ color: 'text.secondary', borderColor: 'text.disabled' }}
        />
    );
}
